<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 p-0">
          <div class="login-card">
            <div>
              <div>
                <a class="logo">
                  <img class="img-fluid logo-mv" src="../assets/images/logo/mexico_verde2.png" alt="Portal México Verde" />
                </a>
              </div>
              <div class="login-main">
                <form class="theme-form">                  
                  
                  <div class="form-group">
                    <label class="col-form-label">Usuario</label>
                    <input class="form-control" :class="{ 'is-invalid': user.usuario.error }"
                      type="text" required="" placeholder="usuario"
                      v-model="user.usuario.value" />
                    <div v-if="user.usuario.error" class="invalid-feedback">
                      {{ user.usuario.errorMessage }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-form-label">Contraseña</label>
                    <div class="form-input position-relative">
                      <input class="form-control" :class="{ 'is-invalid': user.password.error }"
                        type="password" name="login[password]" required=""
                        placeholder="*********" v-model="user.password.value" />
                      <div v-if="user.password.error" class="invalid-feedback">
                        {{ user.password.errorMessage }}
                      </div>
                      <div class="show-hide"><span class="show"> </span></div>
                    </div>
                  </div>
                  <div class="form-group mb-0">
                    <!-- <div class="checkbox p-0">
                      <input id="checkbox1" type="checkbox" />
                      <label class="text-muted" for="checkbox1">Recordar contraseña</label>
                    </div> -->
                    <div class="d-flex justify-content-between mb-3">
                      <router-link class="link" to="Register">
                        Regístrate</router-link>
                      <router-link class="link" to="#">
                        ¿Olvidaste tu contraseña?</router-link>
                    </div>
                    <div class="text-end">
                      <button class="btn btn-primary btn-block w-100" type="submit" @click.prevent="login">
                        Ingresar
                      </button>
                    </div>
                    <div v-if="loginError" class="alert alert-danger mt-3 mb-0" role="alert">
                      {{ loginError }}
                    </div>
                  </div>                  
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="loader-wrapper" v-if="loading">
      <div class="loader-index"><span></span></div>
      <svg>
      <defs></defs>
      <filter id="goo">
        <fegaussianblur in="SourceGraphic" stddeviation="11" result="blur"></fegaussianblur>
        <fecolormatrix in="blur" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9" result="goo"> </fecolormatrix>
      </filter>
    </svg>
    </div>
  </div>
</template>

<script>  
  import config from "@/axios";
  import authService from '@/services/authService';
  import store from '@/store';

  export default { 
    data() {
      return {
        user: {
          usuario: {
            value: '',
            error: false,
            errorMessage: ''
          },
          password: {
            value: '',
            error: false,
            errorMessage: ''
          }
        },
        loading: false,
        loginError: ''
      }
    },         

    methods: {  
      validateForm() {
        let isValid = true;

        // Validar usuario
        if (!this.user.usuario.value.trim()) {
          this.user.usuario.error = true;
          this.user.usuario.errorMessage = 'El usuario es requerido';
          isValid = false;
        } else {
          this.user.usuario.error = false;
          this.user.usuario.errorMessage = '';
        }

        // Validar password
        if (!this.user.password.value) {
          this.user.password.error = true;
          this.user.password.errorMessage = 'La contraseña es requerida';
          isValid = false;
        } else if (this.user.password.value.length < 6) {
          this.user.password.error = true;
          this.user.password.errorMessage = 'La contraseña debe tener al menos 6 caracteres';
          isValid = false;
        } else {
          this.user.password.error = false;
          this.user.password.errorMessage = '';
        }

        return isValid;
      },
      
      async login() {
        if (!this.validateForm()) {
          return;
        }

        this.loading = true;
        this.loginError = '';
        try {
          const response = await config.post("token/", {
            username: this.user.usuario.value,
            password: this.user.password.value
          }, {
            headers: {
                'Content-Type': 'application/json',                 
            },
            timeout: 3000, // 3 seconds timeout   
          });
          
          if (response.data && response.data.access) {
            // Guardar sesión de forma segura (encriptada en sessionStorage)
            authService.saveSession(
              response.data.access,
              response.data.refresh
            );

            // Obtener datos del perfil del usuario
            const meResponse = await config.get('me/', {
              headers: {
                'Authorization': `Bearer ${response.data.access}`
              }
            });
            authService.setUserData(meResponse.data);

            // Cargar menú según perfil
            store.dispatch('menu/initMenu');
            
            // Redirigir al dashboard o página principal
            this.$router.push('/app/bienvenida');
          } else {
            this.loginError = 'Usuario o contraseña incorrectos';
          }
          
        } catch (error) {
          console.error('Error de autenticación:', error);
          if (error.response) {
            // Error de respuesta del servidor (4xx, 5xx)
            if (error.response.status === 401 || error.response.status === 403) {
              this.loginError = 'Usuario o contraseña incorrectos';
            } else {
              this.loginError = 'Error del servidor. Intenta más tarde.';
            }
          } else if (error.request) {
            // Error de conexión
            this.loginError = 'No se pudo conectar con el servidor. Verifica tu conexión.';
          } else {
            this.loginError = 'Ocurrió un error inesperado.';
          }
        } finally {
          this.loading = false;
          if (this.loginError) {
            setTimeout(() => {
              this.loginError = '';
            }, 3000);
          }
        }
      },
      
    },
  };
</script>

<style scoped>
.logo-mv {
  width: 180px;
  height: auto;
  display: block;
  margin: 0 auto 0.5rem;
}
.btn-primary {
  background-color: #09377c !important;
  border-color: #09377c !important;
}
.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active {
  background-color: #0a1e36 !important;
  border-color: #0a1e36 !important;
}
</style>
